<template>
	<div class="uk-container">
		<h1>Hoppla...</h1>

		<div class="uk-margin-large-bottom" v-html="message"></div>

		<div>
			<span uk-icon="mail"></span>&nbsp;<a href="mailto:hilfe@immonex.one">hilfe@immonex.one</a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'error',
	props: ['message'],
	mounted () {
		if (!this.message) this.$router.replace({ name: 'home' })
	}
}
</script>
